/** Xodim profili sarlavhasi uchun o'ng tugma menyusi (test: menu.test.ts). */
import { Ban, ChartColumn, Copy, KeyRound, Link2, Pencil, Phone, UserCheck, Users } from "lucide-react";
import { compactMenu, SEPARATOR, type MenuEntry } from "@/components/ui/context-menu";
import type { Translate } from "@/features/drivers/menu";
import type { PersonProfile } from "./api";
import type { Permission } from "@/features/auth/types";

export interface PersonMenuActions {
  navigate: (path: string) => void;
  copy: (text: string) => void;
  copyLink: () => void;
  call: (phone: string) => void;
  edit: () => void;
  block: () => void;
  unblock: () => void;
  /** Ko'ruvchining ruxsati: hisobotga havola faqat "reports" bo'lsa */
  can: (perm: Permission) => boolean;
  /** Ruxsatlar oynasi (faqat owner, filial menejeri va team lead uchun) */
  access?: () => void;
}

export function personMenu(p: Pick<PersonProfile, "user" | "permissions">, a: PersonMenuActions, t: Translate): MenuEntry[] {
  const u = p.user;
  const manage = p.permissions.can_manage;
  return compactMenu([
    { key: "copy-username", label: t("copyUsername"), icon: Copy, hint: u.username, onSelect: () => a.copy(u.username) },
    !!u.phone && { key: "call", label: t("call"), icon: Phone, hint: u.phone, onSelect: () => a.call(u.phone) },
    !!u.phone && { key: "copy-phone", label: t("copyPhone"), icon: Copy, onSelect: () => a.copy(u.phone) },
    { key: "copy-link", label: t("copyLink"), icon: Link2, onSelect: a.copyLink },
    SEPARATOR,
    u.drivers.total > 0 && { key: "drivers", label: t("user.showDrivers", { count: u.drivers.total }), icon: Users, onSelect: () => a.navigate(`/drivers?owner=${u.id}`) },
    u.role === "recruiter" && !p.permissions.is_self && a.can("reports") && { key: "report", label: t("recruiter.openReport"), icon: ChartColumn, onSelect: () => a.navigate(`/reports?recruiter=${u.id}`) },
    SEPARATOR,
    !!a.access && u.role === "branch_manager" && { key: "access", label: t("user.access"), icon: KeyRound, onSelect: a.access },
    manage && { key: "edit", label: t("edit"), icon: Pencil, onSelect: a.edit },
    manage && u.is_blocked && { key: "unblock", label: t("user.unblock"), icon: UserCheck, onSelect: a.unblock },
    manage && !u.is_blocked && !p.permissions.is_self && { key: "block", label: t("user.block"), icon: Ban, danger: true, onSelect: a.block },
  ]);
}
